import Box from '@mui/material/Box';
import MenuContent from './MenuContent';
import MenuIconOnly from './MenuIconOnly';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronRight } from '@mui/icons-material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { toggleFeature } from '../../app/menu/menuStateSlice.js';
import { ToggleButton } from '../StyledComponents.jsx';

export default function SideMenu() {
  const featureEnabled = useSelector((state) => state.menu.featureEnabled);
  const dispatch = useDispatch();

  return (
    <Box
      sx={{
        overflow: 'auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Spacer above the nav — matches the page background to add spacing */}
      <Box
        sx={{ height: 16, flexShrink: 0, backgroundColor: 'background.default' }}
      />
      {featureEnabled ? <MenuContent /> : <MenuIconOnly open={!featureEnabled} />}
      {/* Collapse toggle — hidden for now. Restore the block below to re-enable.
      <Box
        sx={{
          flexShrink: 0,
          display: 'flex',
          justifyContent: featureEnabled ? 'flex-start' : 'center',
          p: 1,
        }}
      >
        <ToggleButton
          aria-label="toggle sidebar"
          onClick={() => dispatch(toggleFeature())}
          size="small"
        >
          {featureEnabled ? <ChevronLeftIcon /> : <ChevronRight />}
        </ToggleButton>
      </Box>
      */}
    </Box>
  );
}
